<template></template>
<script setup>
import { useLoadingBar } from "naive-ui";
window.$loading = useLoadingBar();
</script>
